module.exports = __webpack_public_path__ + "static/img/Slider_Icon3.7c5d91ab.svg";